// extracted by mini-css-extract-plugin
module.exports = {"TransferConfirmation":"TransferConfirmation_TransferConfirmation__ucfVc"};